import { render, staticRenderFns } from "./HsabExpenseFormSchedule.vue?vue&type=template&id=36af235f&scoped=true"
import script from "./HsabExpenseFormSchedule.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseFormSchedule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af235f",
  null
  
)

export default component.exports